import React, {useState} from 'react';
import {Dimensions, Image, View, StyleSheet} from 'react-native';
import {Button, Input, Text} from 'react-native-elements';
import Emitter from '../../components/Emitter';
import {toast} from 'react-toastify';
import {
  storeAccessToken,
  storeSubId,
  storeUserName,
} from '../../database/DataBase';
import {login} from '../../network/Network';
import {GetNetworkProvider} from '../../network/NetworkProvider';
import {useLinkTo} from '@react-navigation/native';
import MainSiteHeader from '../../components/MainSiteHeader';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default function LoginScreen(props) {

  const linkTo = useLinkTo();
  
  const context = GetNetworkProvider();
  
  const [customerId, setCustomerId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState('');
  const [isCustomerIdValid, setIsCustomerIdValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [customerIdErrMsg, setCustomerIdErrMsg] = useState('CustomerId/Phone is required.');
  const [passwordErrMsg, setPasswordErrMsg] = useState('Password is required.');
  const [isFormTouched, setIsFormTouched] = useState(false);

  const onLoginPress = () => {
    setIsFormTouched(true);
    if(!isCustomerIdValid || !isPasswordValid){
      return;
    }
    setIsLoading(true);
    login(customerId, password)
      .then((data) => {
        if (data.success === true && data.status === 200) {
          toast('Welcome '+data.data.name);
          storeAccessToken(data.data.access_token);
          storeSubId(data.data.subscriber_id);
          storeUserName(data.data.name);
          context.reload();
          Emitter.emit('login', true);
        } else {
          toast(readAllErrors(data.data.message));
        }
        setIsLoading(false);
      })
      .catch((r) => {
        console.log(r);
        toast('Error, try again.');
        setIsLoading(false);
      });
  };

  const readAllErrors = (message) => {
    let errors = '';
    Object.keys(message).forEach((key, index) => {
      message[key].forEach((error) => {
        errors = errors + error + '\n';
      });
    });
    return errors;
  };

  const onForgotPasswordPress = () => {
    linkTo('/customers/forgot_password');
  };
  
  const onSignupPress = () => {
    linkTo('/customers/signup');
  };

  const onCustomerIdChangeText = (input) => {
    setCustomerId(input);
    if(input.length > 0){
      setIsCustomerIdValid(true);
    } else{
      setIsCustomerIdValid(false);
      setCustomerIdErrMsg('CustomerId/Phone number is required.');
      setIsFormTouched(true);
    }
  };

  const onPasswordChangeText = (input) => {
    setPassword(input);
    if(input.length > 0){
      setIsPasswordValid(true);
    } else{
      setIsPasswordValid(false);
      setPasswordErrMsg('Password is required.');
      setIsFormTouched(true);
    }
  };

  return (
    <View style={styles.viewStyle}>
      <MainSiteHeader navigation={props.navigation}/>
        <View style={styles.loginContainer}>
          <View style={[{width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 3, backgroundColor: 'black', padding: 16, alignSelf: 'center'}]}>
          <Image
            source={process.env.PUBLIC_URL + '/assets/ulka-1.png'}
            uri={process.env.PUBLIC_URL + '/assets/ulka-1.png'}
            style={styles.imageStyle}
          />
          <Input
            placeholder={'User Id / Mobile No.'}
            placeholderTextColor="grey"
            value={customerId}
            inputStyle={styles.inputStyle}
            onChangeText={onCustomerIdChangeText}
          />
          {isFormTouched && !isCustomerIdValid && (
            <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{customerIdErrMsg}</Text>
          )}
          <Input
            secureTextEntry={true}
            placeholder={'Password'}
            value={password}
            inputStyle={styles.inputStyle}
            placeholderTextColor="grey"
            onChangeText={onPasswordChangeText}
            containerStyle={{ marginTop: 8}}
          />
          {isFormTouched && !isPasswordValid && (
            <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{passwordErrMsg}</Text>
          )}
          <Button
            loading={isLoading}
            onPress={onLoginPress}
            raised
            containerStyle={styles.buttonContainerStyle}
            buttonStyle={styles.buttonStyle}
            title="Login"
          />
          <View style={styles.moreViewStyle}>
            <Text onPress={onSignupPress} style={styles.textStyle}>
              Signup/Register
            </Text>
            <Text onPress={onForgotPasswordPress} style={styles.textStyle}>
              Forgot password ?
            </Text>
          </View>
        </View>
        </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
    width: WIDTH
  },
  backgroundVideo: {
    flex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    alignItems: "stretch",
    bottom: 0,
    right: 0
  },
  loginContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlignVertical: 'center',
    alignContent: 'center',
    height: HEIGHT-72,
  },
  imageStyle: {height: 100, width: 200, alignSelf: 'center', marginBottom: 24},
  inputStyle: {color: 'white', marginBottom: 8},
  buttonStyle: {
    backgroundColor: 'red',
    height: 50
  },
  buttonContainerStyle: {marginTop: 16},
  moreViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  textStyle: {
    color: 'white',
    fontSize: 16,
    textDecorationLine: true,
  },
});
